import { createAction, props, union } from '@ngrx/store';

export const selectHideInvoiced = createAction('[DeliverySlipFilter] SELECT_HIDE_INVOICED',
  props<{ hideInvoiced: boolean }>());

export const selectShowJobDate = createAction('[DeliverySlipFilter] SELECT_SHOW_JOB_DATE',
  props<{ showJobDate: boolean }>());

export const selectTruck = createAction('[DeliverySlipFilter] SELECT_TRUCK',
  props<{ truckId: number }>());

export const selectCustomer = createAction('[DeliverySlipFilter] SELECT_CUSTOMER',
  props<{ customerId: number}>());

export const setFilterFormExpanded = createAction('[DeliverySlipFilter] SET_FILTER_FORM_EXPANDED', props<{ expanded: boolean }>());

export const DeliverySlipFilterActions = union({ setFilterFormExpanded, selectHideInvoiced, selectShowJobDate, selectTruck, selectCustomer });
